import { Component, Output, OnInit, EventEmitter, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'add-new-metattach-alert-component',
  templateUrl: './add-new-metattach-alert.component.html',
  styleUrls: ['./add-new-metattach-alert.component.scss'],
})
export class AddNewMetattachAlertComponent implements OnInit {
  metattachName: string = "";

  constructor(private modalController: ModalController) { }

  ngOnInit() { }

  addMetattach(){
    this.modalController.dismiss(this.metattachName);
  }
 
  cancel(){
    this.modalController.dismiss();
  }
}